import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { ToastModule } from '../toast/toast.module';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import * as fromP2P from './features/p2p.reducer';
import { StoreModule } from '@ngrx/store';
import { CampaignP2PEffects } from './features/p2p.effects';
import { EffectsModule } from '@ngrx/effects';
import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from "ngx-currency";

@NgModule({
  declarations: [ ],
  imports: [
    StoreModule.forFeature(fromP2P.p2pFeatureKey, fromP2P.reducer),
    EffectsModule.forFeature([CampaignP2PEffects]),
    CommonModule,
    ToastModule,
    MdbPopoverModule,
    MdbSelectModule,
    MdbAutocompleteModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCurrencyDirective,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideEnvironmentNgxCurrency({
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 0,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Financial
  })],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageP2pModule { }
